import * as React from "react";
import { useRef } from "react";
import { LandingStates, SEO } from "../components";
import {
  ContactUs,
  Faq,
  HomeSection1,
  HowItWorks,
  SoftwareDemoVideoContent,
  SolutionSection,
  TableCustomSection,
  Testimonials,
} from "../containers";
import { MainLayout } from "../layouts";

const IndexPage = () => {
  const videoSection = useRef();

  return (
    <MainLayout>
      <HomeSection1 videoSectionRef={videoSection} />
      <Testimonials />
      <SolutionSection />
      <HowItWorks />
      <TableCustomSection />
      <div ref={videoSection}>
        <SoftwareDemoVideoContent />
      </div>
      <Faq />
      <ContactUs />
      <LandingStates />
    </MainLayout>
  );
};

export const Head = () => {
  return (
    <SEO>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: "Client Connect",
            description: "Automated Criminal Defense Marketing",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "5",
              ratingCount: "1",
            },
          }),
        }}
      />
    </SEO>
  );
};

export default IndexPage;
